export default defineNuxtPlugin((nuxtApp) => {
	const { $orderApiService, $messages, $nav } = useNuxtApp()
	const orderStore = useOrderStore()
	const toastStore = useToastStore()

	nuxtApp.provide("orderService", {
		$getUserOrder: async (orderId) => {
			const successHandler = (res) => {
				const order = res.data
				orderStore.updateOrder(order)
			}

			await $orderApiService.$getUserOrder(orderId, successHandler)
		},

		$createDateFromScheduleTo: (dateString) => {
			//Important Note: Assume the scheduleTo date is 9AM PST. Mothership does not store the time, so we assume 9AM.
			const [year, month, day] = dateString.split("-").map(Number)
			return new Date(Date.UTC(year, month - 1, day, 17, 0, 0))
		},

		$resendOrderReceipt: async (orderId) => {
			const successHandler = () => {
				toastStore.setSuccess($messages.$t("emailInvoiceSuccess"))
			}

			await $orderApiService.$resendOrderReceipt(orderId, successHandler)
		},

		$updateOrderPaymentMethod: async (orderId, paymentToken, address) => {
			const requestBody = {
				token: paymentToken,
				user: address,
			}
			const successHandler = () => {
				toastStore.setSuccess($messages.$t("apiSuccess"))
				$nav.$goBack()
			}

			await $orderApiService.$updateOrderPaymentMethod(orderId, requestBody, successHandler)
		},

		$payInstallmentNow: async (orderId, paymentId, paymentToken, reuseToken, address) => {
			const requestBody = {
				token: paymentToken,
				user: address,
				use_this_card_in_future: reuseToken,
			}
			const successHandler = (res) => {
				const order = res.data
				orderStore.updateOrder(order)

				toastStore.setSuccess($messages.$t("apiSuccess"))
				$nav.$goBack()
			}

			await $orderApiService.$payInstallmentNow(orderId, paymentId, requestBody, successHandler)
		},

		$updatePaymentDueDate: async (orderId, paymentId, date) => {
			const requestBody = {
				date: date,
			}
			const successHandler = (res) => {
				const order = res.data
				orderStore.updateOrder(order)
				toastStore.setSuccess($messages.$t("apiSuccess"))
				navigateTo(`/order/${orderId}?view=installments`)
			}

			await $orderApiService.$updatePaymentDueDate(orderId, paymentId, requestBody, successHandler)
		},
	})
})
